import AccountSettings from '../dto/AccountSettings';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubEmployeeAccountSettingsRepository {
    static getData(employeeId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/employees/${employeeId}/account-settings`)
                .then((response) => resolve(AccountSettings.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static updateData(employee) {
        const data = {
            notifyEvents: employee.notifyEvents,
            notifyTasks: employee.notifyTasks,
            notifyNews: employee.notifyNews,
            notifyFiles: employee.notifyFiles,
            notifyOfferings: employee.notifyOfferings,
            hasAvatar: employee.hasAvatar,
            signature: employee.signature,
        };
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/employees/${employee.id}/account-settings`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static avatarUrl(clubEmployeeId, size, forceIgnoreCache) {
        let url = `/api/club/employees/${clubEmployeeId}/account-settings/avatar`;
        const params = new URLSearchParams();
        if (size) {
            params.append('size', size);
        }
        if (forceIgnoreCache) {
            params.append('cb', Date.now());
        }

        const queryString = params.toString();
        if (queryString) {
            url += `?${queryString}`;
        }

        return url;
    }

    static uploadAvatar(clubEmployeeId, avatar, progressCallback) {
        const config = {
            onUploadProgress(progressEvent) {
                if (progressCallback) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    progressCallback(percentCompleted);
                }
            },
            headers: { 'Content-Type': 'application/octet-stream' },
        };

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/employees/${clubEmployeeId}/account-settings/avatar`, avatar, config)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static removeAvatar(clubEmployeeId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/employees/${clubEmployeeId}/account-settings/avatar`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
